import { Component, OnInit } from '@angular/core';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { PopupDatapurchaseTermsComponent } from '../datapurchase/components/popup-datapurchase-terms/popup-datapurchase-terms.component';
@Component({
  selector: 'app-datapurchase',
  templateUrl: './datapurchase.component.html',
  styleUrls: ['./datapurchase.component.sass']
})
export class DatapurchaseComponent implements OnInit {
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public token:string=sessionStorage.getItem("token");
  public tabActive='Compras';
  public SubscriberInfo = [];
  public mixed = false;
  public usage2 = [];
  public expand = [];
  public subscribers;
  public offers:any= [];
  public paymentData;
  public productType;
  public screenview;
  public accountType;
  public accountSubtype;
  loadObserver: Subscription;

  constructor(public dialog: MatDialog, private services: Service,private loadingScreenService :LoadingScreenService, public global:GlobalService, public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Paquetes Adicionales de Datos");
    this.AngularFireAnalytics.logEvent("Paquetes Adicionales de Datos-Screenview");
  }

  ngOnInit() {
    this.expand[0] = true;
    this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
      this.dataLoading(value);
    });
    this.checktype();
    this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.accountType=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
    this.accountSubtype = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
    this.getOffers(this.subscribers,0);
  }
  ngAfterViewInit(){
    this.checktype();
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  mask(data) {
    let start = '( ' + data.toString().substring(0, 3) + ' ) ';
    let middle = data.toString().substring(3, 6) + '-';
    let end = data.toString().substring(6, 10);
    return start + middle + end;
  }
  updateExpand(index) {
    if(this.global.validateSession()===true){
      this.expand[index] = !this.expand[index];
    }
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  checktype(){
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    else{
      this.type=sessionStorage.getItem("tab");
    }
  }

  loadOffers(offers){
    var ofertas = '{"offers":[';
    for (var i=0;i < offers.length;i++ ) {
      if( i > 0) {
        ofertas += ',';
      }
      ofertas += '{"offers":['+JSON.stringify(offers[i])+']}';
    }
    ofertas += ']}';
    this.offers = JSON.parse(ofertas);
    if(this.subscribers.length>0){
      this.expand[0]=true;
    }
    this.loadingScreenService.stopLoading();
  }
  offersData(data,row){
    if(data.Offers.length>0){
      var count=0;
      var cont1=data.Offers.length;
      if(cont1>1){
        count=Math.ceil((cont1/ row));
      }
      else{
        count=1;
      }
      var offers = '{"offersData":[';
      var contador=0;
      for (var i=0;i < count;i++ ) {

        if( i > 0) {
          offers += ',';
        }
        offers += '{"offers":[';
        for (var j=contador;j < (contador+row); j++ ) {
          if(data.Offers[j]!==undefined){
            if( j > contador) {
              offers += ',';
            }
            offers += '{"DisplayName":"' + data.Offers[j].DisplayName + '","Price":"' + data.Offers[j].Price + '","OfferId":"' + data.Offers[j].OfferId + '"}';
          }
        }
        contador=contador+3;
        offers += ']}';

      }
      offers += ']}';
    }
    else{
      var offers = '{"offersData":[]}';
    }

    return offers;
  }
  dataLoading(sw){
    this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.accountType=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
    this.accountSubtype = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.getOffers(this.subscribers,0);
    this.checktype();
    setTimeout(() => {
      this.global.loadCanvas();
    }, 2000);
  }
  getOffers(subscriber,index){
    let offerID="";
    this.productType=this.subscribers[index].productTypeField;
    if(this.productType===subscriber[index].productTypeField){
      if (subscriber[index].groupIDField === 'undefined' || subscriber[index].groupIDField === null || subscriber[index].groupIDField === '') {
        // ofertas individuales

        if(this.aplicaDiario10(this.productType,subscriber[index].planInfoField.sOCInfoField,subscriber[index].servSVAInfoField.servSVAsField)==true){
          offerID="DIARIO10";
        }
        this.services.getOffers("",subscriber[index].subscriberNumberField,"12345",offerID).subscribe(data => {
          if ((parseInt(subscriber.length)-1) === index) {
            this.offers.push(JSON.parse(this.offersData(data,3)));
            this.loadOffers(this.offers);
          }
          else{
            this.offers.push(JSON.parse(this.offersData(data,3)));
            this.getOffers(subscriber,parseInt(index+1))
          }
        });
      }
      else{
        if(this.aplicaDiario10(this.productType,subscriber[index].planInfoField.sOCInfoField,subscriber[index].servSVAInfoField.servSVAsField)==true){
          offerID="DIARIO10";
        }
        this.services.getOffersGrupo(subscriber[index].groupIDField,subscriber[index].subscriberNumberField,"12345").subscribe(data => {
          if ((parseInt(subscriber.length)-1) === index) {
            this.offers.push(JSON.parse(this.offersData(data,3)));
            this.loadOffers(this.offers);
          }
          else{
            this.offers.push(JSON.parse(this.offersData(data,3)));
            this.getOffers(subscriber,parseInt(index+1))
          }
        });
      }
    }
    else{
      if ((parseInt(subscriber.length)-1) === index) {
        this.loadingScreenService.stopLoading();
      }
      else{
        this.getOffers(subscriber,parseInt(index+1))
      }
    }
  }
  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.initializeData();
  }
  aplicaDiario10(productType, planUpdate, sva) {
    let comprobacion = false;
    if ((this.accountType== 'I2' && this.accountSubtype == '4') || (this.accountType== 'I3' && this.accountSubtype == '4') || (this.accountType == 'I' && this.accountSubtype == 'S') || (this.accountType == 'I' && this.accountSubtype == 'W')) {
      if (productType == 'G') {
        comprobacion = true;
      }
    }
    return comprobacion;
  }
  displayTerms(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(PopupDatapurchaseTermsComponent, dialogConfig);
  }
}
